// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"styles_dashboard__15e7d","spinnerStyle":"styles_spinnerStyle__18dHk"};